import { useMutation } from "@shared/lib/hooks";
import { IBrandBilling } from "@shared/lib/types/brandBilling";
import { ORGANISATION_LIST_QUERY_KEY } from "../constants";
import { OrganisationService } from "../services/organisation.service";

export function useEditSingleModeBilling(brandOrganisationId: string) {
  const {
    mutate: edit,
    isLoading: isEditing,
    isSuccess: isEdited,
    error: editSingeModeError,
    variables,
  } = useMutation({
    mutationFn: (payload: {
      brandOrganisationId: string;
      brandBillingDetails: IBrandBilling;
    }) => OrganisationService.editSingleModeBilling(payload),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...ORGANISATION_LIST_QUERY_KEY, brandOrganisationId],
      });
    },
  });

  return {
    edit,
    isEditing,
    isEdited,
    editSingeModeError,
    variables,
  };
}
